import participantAgeWidget from '@/store/widgets/modules/participantAgeWidget';

export default {
    namespaced: true,
    modules: {
        participantAgeWidget
    }
};
